import { c as _c } from "react/compiler-runtime";
import { type FC } from "react";
import { type IconType } from "react-icons";
interface BigStatCardProps {
  label: string;
  value: string;
  subtext: string;
  icon: IconType | FC<{
    className?: string;
  }>;
  theme?: "brand" | "gold" | "danger";
}
export const BigStatCard: FC<BigStatCardProps> = t0 => {
  const $ = _c(17);
  const {
    label,
    value,
    subtext,
    icon: Icon,
    theme: t1
  } = t0;
  const theme = t1 === undefined ? "brand" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      brand: "text-brand-600 dark:text-brand-400 border-brand-200 dark:border-brand-500/20 bg-brand-50 dark:bg-brand-900/10",
      gold: "text-gold-600 dark:text-gold-400 border-gold-200 dark:border-gold-500/20 bg-gold-50 dark:bg-gold-900/10",
      danger: "text-danger-500 dark:text-danger-500 border-danger-500/20 dark:border-danger-500/20 bg-danger-900/10 dark:bg-danger-900/10"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const themeClasses = t2;
  const t3 = `p-6 rounded-xl border ${themeClasses[theme]} flex flex-col h-full hover:scale-[1.02] transition-transform`;
  let t4;
  if ($[1] !== label) {
    t4 = <span className="text-sm font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">{label}</span>;
    $[1] = label;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== Icon) {
    t5 = <Icon className="w-6 h-6 opacity-80" />;
    $[3] = Icon;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <div className="flex justify-between items-start mb-4">{t4}{t5}</div>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== value) {
    t7 = <div className="text-3xl md:text-4xl font-black font-mono mb-2">{value}</div>;
    $[8] = value;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== subtext) {
    t8 = <p className="text-xs text-slate-500 dark:text-slate-400 mt-auto leading-relaxed">{subtext}</p>;
    $[10] = subtext;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = <div className={t3}>{t6}{t7}{t8}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};